import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "style__Container",
  componentId: "sc-190khkd-0"
})(["display:flex;flex-direction:row;position:fixed;bottom:0;width:100%;height:30px;background-color:", ";padding-bottom:10px;padding-top:5px;z-index:1000;"], function (props) {
  return props.color ? props.color : 'transparent';
});
export var Logo = styled.img.withConfig({
  displayName: "style__Logo",
  componentId: "sc-190khkd-1"
})(["height:20px;margin-left:50px;bottom:0;"]);
export var Description = styled.div.withConfig({
  displayName: "style__Description",
  componentId: "sc-190khkd-2"
})(["line-height:22px;font-weight:bold;margin-right:50px;text-align:center;color:#7b7a77;width:70%;"]);
export var CancelText = styled.div.withConfig({
  displayName: "style__CancelText",
  componentId: "sc-190khkd-3"
})(["line-height:22px;right:0;font-weight:bold;margin-right:10px;margin-bottom:35px;text-align:right;color:#000;width:20%;cursor:pointer;"]);